import { getSnapshot, isStateTreeNode } from 'mobx-state-tree';

import type {
  InteractivityAction,
  InteractivityActionSnapshotOut,
} from '../actions/InteractivityAction';
import type {
  InteractivityActions,
  InteractivityActionsSnapshotOut,
} from '../actions/InteractivityActions';
import { walkInteractivityActionInstanceTree } from '../actions/utils/walkInteractivityActionInstanceTree';
import { walkInteractivityActionTree } from '../actions/utils/walkInteractivityActionTree';
import { InteractivityEventTypeValue } from '../events/InteractivityEventTypeValue';
import type { Interactivities, InteractivitiesSnapshotOut } from '../Interactivities';

export function containsInteractivityAction({
  interactivities,
  interactivityActions,
  containsFn,
}: {
  interactivities: Interactivities | InteractivitiesSnapshotOut | undefined;
  interactivityActions:
    | InteractivityActions
    | InteractivityActionsSnapshotOut
    | undefined;
  containsFn: (
    interactivityAction: InteractivityActionSnapshotOut,
    eventType: InteractivityEventTypeValue,
  ) => boolean;
}): boolean {
  if (!interactivities || !interactivityActions) {
    return false;
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const eventType of Object.values(
    InteractivityEventTypeValue,
  ) as InteractivityEventTypeValue[]) {
    const interactivityActionRef = interactivities[eventType];

    if (interactivityActionRef) {
      const iAction = isStateTreeNode(interactivityActions)
        ? interactivityActions.get(interactivityActionRef)
        : interactivityActions[interactivityActionRef];

      if (iAction) {
        let found = false;

        if (isStateTreeNode(iAction)) {
          walkInteractivityActionInstanceTree(iAction as InteractivityAction, ia => {
            if (containsFn(getSnapshot(ia), eventType)) {
              found = true;
            }
          });
        } else {
          walkInteractivityActionTree(iAction, ia => {
            if (containsFn(ia, eventType)) {
              found = true;
            }
          });
        }

        if (found) {
          return true;
        }
      }
    }
  }

  return false;
}
